import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

/**
 * Tooltip Component
 * Shows helpful information on hover/click (mobile-friendly)
 */
export default function Tooltip({ children, content, position = 'right' }) {
  const [isVisible, setIsVisible] = useState(false)

  const positionClasses = {
    right: 'left-full ml-2 top-0 md:top-1/2 md:-translate-y-1/2',
    left: 'right-full mr-2 top-0 md:top-1/2 md:-translate-y-1/2',
    top: 'bottom-full mb-2 left-1/2 -translate-x-1/2',
    bottom: 'top-full mt-2 left-1/2 -translate-x-1/2',
  }

  return (
    <div className="relative inline-block">
      <div
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onClick={() => setIsVisible(!isVisible)}
        className="cursor-help"
      >
        {children}
      </div>
      
      <AnimatePresence>
        {isVisible && (
          <>
            {/* Backdrop for mobile */}
            <div
              className="fixed inset-0 z-40 md:hidden"
              onClick={() => setIsVisible(false)}
            />
            
            <motion.div
              initial={{ opacity: 0, scale: 0.9, y: position === 'right' || position === 'left' ? -10 : 0 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: position === 'right' || position === 'left' ? -10 : 0 }}
              transition={{ duration: 0.15 }}
              className={`absolute z-50 ${positionClasses[position]} pointer-events-auto md:pointer-events-none`}
            >
              <div className="bg-gray-900 border-2 border-pitch-green/50 rounded-lg p-4 md:p-5 shadow-2xl w-[320px] sm:w-[380px] md:w-[420px] lg:w-[480px]">
                <div className="text-sm md:text-base text-gray-200 space-y-2.5 leading-relaxed">
                  {content}
                </div>
                {/* Arrow - hidden on mobile for right/left positions */}
                {position === 'right' && (
                  <div className="hidden md:block absolute right-full top-1/2 -translate-y-1/2 border-8 border-transparent border-r-pitch-green/50" />
                )}
                {position === 'left' && (
                  <div className="hidden md:block absolute left-full top-1/2 -translate-y-1/2 border-8 border-transparent border-l-pitch-green/50" />
                )}
                {position === 'top' && (
                  <div className="absolute bottom-full left-1/2 -translate-x-1/2 border-8 border-transparent border-b-pitch-green/50" />
                )}
                {position === 'bottom' && (
                  <div className="absolute top-full left-1/2 -translate-x-1/2 border-8 border-transparent border-t-pitch-green/50" />
                )}
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  )
}
